import { createAction, props } from '@ngrx/store';
import { AppointmentRequestActivityType } from '@warema/shared/models';

export const ActivitySelected = createAction(
    '[CompanySearch] Activity Selected',
    props<{ activityType: AppointmentRequestActivityType }>(),
);

export const resetSelectedActivity = createAction('[CompanySearch] Reset selected activity');
